"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdornmentRightMixin = exports.AdornmentMixin = exports.AdornmentLeftMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _InputMixin = require("./InputMixin");
/** @class AdornmentLeftMixin */
/** @method */
var AdornmentLeftMixin = function AdornmentLeftMixin(props) {
  return (0, _styledToken.default)({
    borderRight: 'Adornment.Right.borderRight',
    borderTopRightRadius: 'Adornment.Right.borderTopRightRadius',
    borderBottomRightRadius: 'Adornment.Right.borderBottomRightRadius'
  }, function (_ref) {
    var _ref$borderRight = _ref.borderRight,
      borderRight = _ref$borderRight === void 0 ? 0 : _ref$borderRight,
      _ref$borderTopRightRa = _ref.borderTopRightRadius,
      borderTopRightRadius = _ref$borderTopRightRa === void 0 ? 0 : _ref$borderTopRightRa,
      _ref$borderBottomRigh = _ref.borderBottomRightRadius,
      borderBottomRightRadius = _ref$borderBottomRigh === void 0 ? 0 : _ref$borderBottomRigh;
    return (0, _styledComponents.css)(["border-top-right-radius:", "px;border-bottom-right-radius:", "px;border-right:", ";"], borderTopRightRadius, borderBottomRightRadius, borderRight);
  })(props);
};

/** @class AdornmentRightMixin */
/** @method */
exports.AdornmentLeftMixin = AdornmentLeftMixin;
var AdornmentRightMixin = function AdornmentRightMixin(props) {
  return (0, _styledToken.default)({
    borderLeft: 'Adornment.Left.borderLeft',
    borderTopLeftRadius: 'Adornment.Left.borderTopLeftRadius',
    borderBottomLeftRadius: 'Adornment.Left.borderBottomLeftRadius'
  }, function (_ref2) {
    var _ref2$borderLeft = _ref2.borderLeft,
      borderLeft = _ref2$borderLeft === void 0 ? 0 : _ref2$borderLeft,
      _ref2$borderTopLeftRa = _ref2.borderTopLeftRadius,
      borderTopLeftRadius = _ref2$borderTopLeftRa === void 0 ? 0 : _ref2$borderTopLeftRa,
      _ref2$borderBottomLef = _ref2.borderBottomLeftRadius,
      borderBottomLeftRadius = _ref2$borderBottomLef === void 0 ? 0 : _ref2$borderBottomLef;
    return (0, _styledComponents.css)(["border-top-left-radius:", "px;border-bottom-left-radius:", "px;border-left:", ";"], borderTopLeftRadius, borderBottomLeftRadius, borderLeft);
  })(props);
};
exports.AdornmentRightMixin = AdornmentRightMixin;
var zsgCSS = (0, _styledToken.default)('Input.adornmentColor', function (color) {
  return color && "\n        &[disabled] {\n            color: " + color + ";\n        }\n    ";
});

/** @class AdornmentMixin */
/** @method */
var AdornmentMixin = function AdornmentMixin(props) {
  return (0, _styledToken.default)('Input.adornmentColor', function (color) {
    return (0, _styledComponents.css)(["", " color:", ";width:auto;display:inline-flex;align-items:center;user-select:none;", ""], (0, _InputMixin.InputMixin)(props), color, zsgCSS(props));
  })(props);
};
exports.AdornmentMixin = AdornmentMixin;